
import { useDispatch, useSelector } from 'react-redux'
import { useRef } from 'react'
import type { RootState } from '../../app/store'
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import FormControl from 'react-bootstrap/FormControl';
import FormGroup from 'react-bootstrap/FormGroup';
import FormLabel from 'react-bootstrap/FormLabel';
import FormCheck from 'react-bootstrap/FormCheck';
import { Formik, Field, Form } from 'formik';
import { signIn } from '../../reducers/authSlice';
import { SigninSchema } from '../../validate/authSchema';
import CustomeToast from '../../components/CustomeToast';
import './SignIn.scss';

const SignInPage = () => {
    const dispatch = useDispatch();
    const { loading } = useSelector((state: RootState) => state.auth)
    const customeToastRef = useRef(null);

    return (
        <div id="signin-page">
            <div className='content'>
                <Formik
                    initialValues={{
                        identifier: process.env.NODE_ENV === 'development' ? 'admin1102' : '',
                        password: process.env.NODE_ENV === 'development' ? '' : '',
                    }}
                    validationSchema={SigninSchema}
                    onSubmit={(values) => {
                        console.log(values);
                        dispatch(signIn(values));
                    }}
                    render={({ values, errors, touched, validateForm }) => (
                        <Form>
                            <h2 className='text-center'>Đăng nhập</h2>
                            <Field
                                name="identifier"
                                render={({ field, formProps }) => (
                                    <FormGroup className="mb-3" controlId="identifier">
                                        <FormLabel>Email/Username</FormLabel>
                                        <FormControl type="identifier" placeholder="Nhập email hoặc username" value={field.value} onChange={field.onChange} />
                                        {errors.identifier && touched.identifier ? (
                                            <div style={{ color: "red" }}>{errors.identifier}</div>
                                        ) : null}
                                    </FormGroup>
                                )}
                            />
                            <Field
                                name="password"
                                render={({ field, formProps }) => (
                                    <FormGroup className="mb-3" controlId="password">
                                        <FormLabel>Mật khẩu</FormLabel>
                                        <FormControl type="password" placeholder="Nhập mật khẩu" value={field.value} onChange={field.onChange} />
                                        {errors.password && touched.password ? (
                                            <div style={{ color: "red" }}>{errors.password}</div>
                                        ) : null}
                                    </FormGroup>
                                )}
                            />
                            <FormGroup className="mb-3" controlId="formBasicCheckbox">
                                <FormCheck type="checkbox" label="Ghi nhớ đăng nhập" />
                            </FormGroup>
                            <FormGroup className="mb-3 text-center">
                                <Button variant="primary" type="submit" onClick={validateForm}>
                                    Đăng nhập
                                </Button>
                            </FormGroup>
                        </Form>
                    )}
                >
                </Formik>
                <CustomeToast ref={customeToastRef} />
                {loading &&
                    <div className='loading'>
                        <Spinner animation="border" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </Spinner>
                    </div>
                }
            </div>
        </div>
    );
}

export default SignInPage;
